import { css } from '@emotion/react'
import { medium } from '../../GlobalStyles'



export const WrapperStyle = css`

    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: calc(100vh - 115px);

    ${medium}{
        flex-direction: column;
    }
`

export const LeftSideBarStyle = css`
    min-width: 298px;
    max-width: 298px;
`

export const RightSideBarStyle = css`
  width: 224px;
`

export const MainContentWrapperStyle = css`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    margin: 0px 88px;
    margin-top: 3rem;
    word-break: break-word;


    ${medium}{
        margin: 3rem 5% 0px 5%;
    }

`